import get from 'lodash/get';
import store from "@app2/store";
import { hasPermission } from '@app2/utils/filters';
import { getCookie, removeCookie } from "@app2/utils/helpers";

export const blueprintGuard = async (to, from, next) => {
    // Get necessary information from the user and the store
    const user = get(store, 'state.auth.user');
    const cookie = getCookie('blueprint');
    if ( !cookie || !user ) {
        next();
        return;
    }

    // Determine the appropriate route based on existence of hub
    if (!hasPermission('hubs', user)) {
      removeCookie('blueprint');
      next({ name: 'AccountAddons', query: { action: 'create_from_blueprint' } });
    } else {
        next({ name: 'OnboardingCreate' });
    }
};